/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiUpdateUserAvailabilityRequestFromJSON(json) {
    return StreemApiUpdateUserAvailabilityRequestFromJSONTyped(json, false);
}
export function StreemApiUpdateUserAvailabilityRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'availabilityStatus': !exists(json, 'availability_status') ? undefined : json['availability_status'],
    };
}
export function StreemApiUpdateUserAvailabilityRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'availability_status': value.availabilityStatus,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiUpdateUserAvailabilityRequestAvailabilityStatus;
(function (StreemApiUpdateUserAvailabilityRequestAvailabilityStatus) {
    StreemApiUpdateUserAvailabilityRequestAvailabilityStatus["AVAILABLE"] = "AVAILABILITY_STATUS_AVAILABLE";
    StreemApiUpdateUserAvailabilityRequestAvailabilityStatus["CONFIRMING"] = "AVAILABILITY_STATUS_CONFIRMING";
    StreemApiUpdateUserAvailabilityRequestAvailabilityStatus["INVALID"] = "AVAILABILITY_STATUS_INVALID";
    StreemApiUpdateUserAvailabilityRequestAvailabilityStatus["INCALL"] = "AVAILABILITY_STATUS_IN_CALL";
    StreemApiUpdateUserAvailabilityRequestAvailabilityStatus["NOTAVAILABLE"] = "AVAILABILITY_STATUS_NOT_AVAILABLE";
    StreemApiUpdateUserAvailabilityRequestAvailabilityStatus["OFFLINE"] = "AVAILABILITY_STATUS_OFFLINE";
    StreemApiUpdateUserAvailabilityRequestAvailabilityStatus["RESERVED"] = "AVAILABILITY_STATUS_RESERVED";
})(StreemApiUpdateUserAvailabilityRequestAvailabilityStatus || (StreemApiUpdateUserAvailabilityRequestAvailabilityStatus = {}));
//# sourceMappingURL=StreemApiUpdateUserAvailabilityRequest.js.map